import type {
  FieldQuery,
  FieldQueryData,
  SectionQuery,
  SectionQueryData,
  ContestManageStore,
} from '../types/store';

import type {
  InitAction,
  RemoveFieldAction,
  RemoveFieldCacheAction,
  RemoveSectionAction,
  RemoveSectionCacheAction,
  SetFieldAction,
  SetFieldCacheAction,
  SetSectionAction,
  SetSectionCacheAction,
  UpdateFieldAction,
  UpdateFieldCacheAction,
  UpdateSectionAction,
  UpdateSectionCacheAction,
} from './types/actions';

export const createInitAction = (state: ContestManageStore): InitAction => ({
  type: 'INIT',
  payload: state,
});

export const createSetFieldAction = (key: string, data: FieldQuery): SetFieldAction => ({
  type: 'SET_FIELD',
  operation: 'SET',
  payload: {
    key,
    data,
  },
});

export const createRemoveFieldAction = (key: string): RemoveFieldAction => ({
  type: 'REMOVE_FIELD',
  operation: 'REMOVE',
  payload: {
    key,
  },
});

export const createUpdateFieldAction = (
  key: string,
  data: Partial<FieldQuery>
): UpdateFieldAction => ({
  type: 'UPDATE_FIELD',
  operation: 'UPDATE',
  payload: {
    key,
    data,
  },
});

export const createSetSectionAction = (key: string, data: SectionQuery): SetSectionAction => ({
  type: 'SET_SECTION',
  operation: 'SET',
  payload: {
    key,
    data,
  },
});

export const createRemoveSectionAction = (key: string): RemoveSectionAction => ({
  type: 'REMOVE_SECTION',
  operation: 'REMOVE',
  payload: {
    key,
  },
});

export const createUpdateSectionAction = (
  key: string,
  data: Partial<SectionQuery>
): UpdateSectionAction => ({
  type: 'UPDATE_SECTION',
  operation: 'UPDATE',
  payload: {
    key,
    data,
  },
});

export const createSetFieldCacheAction = (
  key: string,
  data: FieldQueryData
): SetFieldCacheAction => ({
  type: 'SET_FIELD_CACHE',
  operation: 'SET',
  payload: {
    key,
    data,
  },
});

export const createRemoveFieldCacheAction = (key: string): RemoveFieldCacheAction => ({
  type: 'REMOVE_FIELD_CACHE',
  operation: 'REMOVE',
  payload: {
    key,
  },
});

export const createUpdateFieldCacheAction = (
  key: string,
  data: Partial<FieldQueryData>
): UpdateFieldCacheAction => ({
  type: 'UPDATE_FIELD_CACHE',
  operation: 'UPDATE',
  payload: {
    key,
    data,
  },
});

export const createSetSectionCacheAction = (
  key: string,
  data: SectionQueryData
): SetSectionCacheAction => ({
  type: 'SET_SECTION_CACHE',
  operation: 'SET',
  payload: {
    key,
    data,
  },
});

export const createRemoveSectionCacheAction = (key: string): RemoveSectionCacheAction => ({
  type: 'REMOVE_SECTION_CACHE',
  operation: 'REMOVE',
  payload: {
    key,
  },
});

export const createUpdateSectionCacheAction = (
  key: string,
  data: Partial<SectionQueryData>
): UpdateSectionCacheAction => ({
  type: 'UPDATE_SECTION_CACHE',
  operation: 'UPDATE',
  payload: {
    key,
    data,
  },
});
